import { SearchFormData, SearchResult } from '../types';

export const buildAIProfileData = (
  data: SearchResult,
  searchCriteria?: SearchFormData | null,
): Record<string, unknown> => {
  const contactInfo = data?.results?.personal_info?.records?.[0]?.contact_info;

  const profileData: Record<string, unknown> = {
    first_name: searchCriteria?.FIRST_NAME || contactInfo?.first_name || '',
    last_name: searchCriteria?.LAST_NAME || contactInfo?.last_name || '',
    city: searchCriteria?.CITY || contactInfo?.city || '',
    state: searchCriteria?.STATE || contactInfo?.state || '',
    street: searchCriteria?.STREET1 || '',
    zip: searchCriteria?.ZIP || '',
  };

  Object.keys(data).forEach(key => {
    profileData[key] = data[key];
  });

  profileData.source = 'Knowledge Core IQ Search';
  profileData.search_timestamp = new Date().toISOString();

  return profileData;
};
